module.exports = __webpack_public_path__ + "f25a5a029252dbb7238b693a2dcc0478.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg40.jpeg
// module id = 51
// module chunks = 0